var _path, _path2;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImportPoly(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 2.60873C10.9004 2.60874 11.2246 2.93294 11.2246 3.33334V9.91635L12.4873 8.65366C12.7704 8.37074 13.2296 8.37074 13.5127 8.65366C13.7958 8.93674 13.7957 9.3959 13.5127 9.67905L11.0127 12.179C10.7296 12.4622 10.2704 12.4622 9.9873 12.179L7.4873 9.67905C7.20433 9.3959 7.20423 8.93674 7.4873 8.65366C7.77039 8.37075 8.22961 8.37075 8.5127 8.65366L9.77539 9.91635V3.33334C9.77539 2.93294 10.0996 2.60873 10.5 2.60873Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.166 9.27539C17.5664 9.27539 17.8916 9.5996 17.8916 10C17.8916 14.0822 14.5822 17.3914 10.5 17.3916C6.4177 17.3916 3.1084 14.0823 3.1084 10C3.1084 9.59961 3.4326 9.27539 3.83301 9.27539C4.23341 9.27539 4.55762 9.59961 4.55762 10C4.55762 13.2815 7.2185 15.9414 10.5 15.9414C13.7814 15.9412 16.4414 13.2814 16.4414 10C16.4414 9.59971 16.7658 9.27557 17.166 9.27539Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.2
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImportPoly);
export default __webpack_public_path__ + "static/media/import-poly.3d15440cc7ea252333b7145bd5ca0e7d.svg";
export { ForwardRef as ReactComponent };